import { useState } from 'react'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card'
import { Button, ButtonText } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Description } from '@/components/ui/Description'
import {
  useMarketingWording,
  useSaveMarketingChoice,
} from '@/services/api/auth/useMarketingConsent'

/**
 * Shown after a Google / Facebook / Xero sign-up, before the user enters the
 * app: a sign-in from a provider is not consent to marketing emails, so the
 * box starts unticked and Continue without it is a "no" (14zfmu12gr2).
 */
export default function MarketingChoiceScreen() {
  const [optedIn, setOptedIn] = useState(false)
  const { data: wording, isError } = useMarketingWording()
  const { saveChoice, saveChoiceStatus } = useSaveMarketingChoice()

  const submit = () => {
    if (!wording) return
    saveChoice({
      optedIn,
      source: 'social',
      wordingVersion: wording.version,
    }).catch(() => setOptedIn(false))
  }

  return (
    <div className="pf-auth grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>One more step</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4">
            <Description>
              Choose whether you'd like emails from us. You can change this any
              time in your account settings.
            </Description>
            {wording ? (
              <label className="flex cursor-pointer items-start gap-2 text-sm text-txt-secondary">
                <Checkbox
                  className="mt-0.5 shrink-0"
                  checked={optedIn}
                  onCheckedChange={(checked) => setOptedIn(!!checked)}
                />
                <span>{wording.text}</span>
              </label>
            ) : (
              <Description>
                {isError
                  ? 'Something went wrong. Please reload the page.'
                  : 'Loading…'}
              </Description>
            )}
            {saveChoiceStatus.isError && (
              <p className="text-xs text-txt-error">
                Your choice wasn't saved. Please check the text above and try
                again.
              </p>
            )}
          </div>
        </CardContent>
        <CardFooter>
          <Button
            size="lg"
            className="w-full"
            disabled={!wording}
            loading={saveChoiceStatus.isPending}
            onClick={submit}
          >
            <ButtonText>Continue</ButtonText>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
